/* Farmer to Baller Shopify analytics. Canonical source: packages/shopify-posthog. */
(function () {
  'use strict';
  const c = window.FTBStore;
  if (!c || window.FTBAnalytics) return;
  const preview = c.qaTheme;
  const blocked = /\/(account|checkouts?|orders)(\/|$)|contact|kontakt/.test(location.pathname);
  let sdk, loading = false, started = false, activeMode = 'pending', resolveReady;
  const ready = new Promise(resolve => { resolveReady = resolve; });
  const mode = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return 'pending';
    // An explicit rejection wins even in regions where Shopify otherwise permits analytics.
    if (privacy.currentVisitorConsent?.().analytics === 'no') return 'cookieless';
    // In consent-required markets, an unanswered banner uses cookieless mode.
    return privacy.analyticsProcessingAllowed?.() === true ? 'full' : 'cookieless';
  };
  const explicitConsent = () => {
    const value = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
    const choice = key => value[key] === 'yes' ? 'yes' : value[key] === 'no' ? 'no' : 'unanswered';
    return { analytics:choice('analytics'), marketing:choice('marketing'), preferences:choice('preferences') };
  };
  const consentState = () => {
    const analytics = explicitConsent().analytics;
    return analytics === 'yes' ? 'accepted' : analytics === 'no' ? 'rejected'
      : mode() === 'full' ? 'permitted_without_choice' : 'unanswered';
  };
  const allowed = () => mode() === 'full';
  const cleanUrl = value => { try { const u = new URL(value); u.search='';u.hash='';return u.href; } catch { return ''; } };
  const entry = (() => {
    const url = new URL(location.href);
    let referrer = '';
    try { referrer = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch {}
    const source = (url.searchParams.get('utm_source') || '').toLowerCase().slice(0,80);
    const medium = (url.searchParams.get('utm_medium') || '').toLowerCase().slice(0,80);
    const campaign = (url.searchParams.get('utm_campaign') || '').slice(0,120);
    const metaClick = url.searchParams.has('fbclid') || url.searchParams.has('fbc');
    const googleClick = url.searchParams.has('gclid') || url.searchParams.has('gbraid') || url.searchParams.has('wbraid');
    const sourceHint = metaClick || /^(facebook|instagram|meta|fb|ig)$/.test(source) || /(^|\.)(facebook|instagram|fb)\.com$/.test(referrer) ? 'meta'
      : googleClick || source === 'google' || /(^|\.)google\.[a-z.]+$/.test(referrer) ? 'google'
      : source || referrer ? 'other' : 'direct_or_unknown';
    return {entry_path:url.pathname,referrer_host:referrer || null,
      utm_source:source || null,utm_medium:medium || null,utm_campaign:campaign || null,
      meta_click_id_present:metaClick,google_click_id_present:googleClick,entry_source_hint:sourceHint};
  })();
  const entryProperties = () => allowed() ? entry : {
    meta_click_id_present:entry.meta_click_id_present,
    google_click_id_present:entry.google_click_id_present,
    entry_source_hint:entry.entry_source_hint,
  };
  const base = { store_id:c.storeId, shopify_store:c.shop, storefront:location.hostname, market:c.market, currency:c.currency, is_test:false };
  const product = () => ({ product_id:c.productId || null, product_handle:c.productHandle || null });
  const sessionKey = 'ftb:'+c.storeId+':session';
  const sessionTimeKey = sessionKey + ':at';
  let lastConsentChange = '';
  function rememberSession() {
    if (!sdk || !allowed()) return;
    try {
      localStorage.setItem('ftb:'+c.storeId+':distinct', sdk.get_distinct_id());
      const session = sdk.get_session_id?.();
      if (session) { localStorage.setItem(sessionKey, session); localStorage.setItem(sessionTimeKey, String(Date.now())); }
    } catch {}
  }
  window.FTBAnalytics = {
    ready, allowed, mode,
    distinctId() { return sdk && allowed() ? sdk.get_distinct_id() : ''; },
    capture(event, properties) {
      const choice = mode();
      if (sdk && choice !== 'pending') { rememberSession(); sdk.capture(event, { ...base, ...properties,
        ...(window.FTBStickyTest?.active && !window.FTBStickyTest.qa ? {
          experiment_key:window.FTBStickyTest.key,experiment_variant:window.FTBStickyTest.arm,enrollment_id:window.FTBStickyTest.enrollmentId
        } : {}), tracking_mode:choice, consent_state:consentState() }); }
    }
  };
  function applyMode() {
    if (!sdk) { start(); return; }
    const choice = mode();
    if (choice === activeMode) return;
    activeMode = choice;
    if (choice === 'full') {
      sdk.opt_in_capturing();
      sdk.setPersonPropertiesForFlags({store_id:c.storeId,market:c.market,currency:c.currency});
      rememberSession();
    } else {
      sdk.stopSessionRecording();
      try { localStorage.removeItem('ftb:'+c.storeId+':distinct'); localStorage.removeItem(sessionKey); localStorage.removeItem(sessionTimeKey); } catch {}
      if (choice === 'cookieless') sdk.opt_out_capturing();
    }
    if (choice !== 'pending') {
      sdk.capture('$pageview', { ...base, ...entryProperties(), tracking_mode:choice, consent_state:consentState() });
      if (c.productId) sdk.capture('product_viewed', { ...base, ...product(), variant_id:c.variantId || null, tracking_mode:choice, consent_state:consentState() });
    }
    document.dispatchEvent(new Event('ftb:analytics-mode'));
  }
  function init() {
    if (started || mode() === 'pending' || !window.posthog) return;
    started = true;
    window.posthog.init(c.token, {
      api_host:'https://eu.i.posthog.com', ui_host:'https://eu.posthog.com', defaults:'2026-05-30',
      cookieless_mode:'on_reject',
      persistence:'localStorage', persistence_name:'ftb_'+c.storeId, cross_subdomain_cookie:false,
      person_profiles:'never', capture_pageview:false, capture_pageleave:true,
      mask_all_text:true, mask_all_element_attributes:true,
      autocapture:true, capture_heatmaps:true, capture_exceptions:true,
      session_recording:{ maskAllInputs:true, maskTextSelector:'.ph-mask, .customer, [data-customer], .shopify-policy__body', blockSelector:'iframe, .ph-no-capture', recordHeaders:false,recordBody:false, streamNetworkBody:false, captureJsonLd:false, maskCapturedNetworkRequestFn: request => ({...request,url:cleanUrl(request.url)}) },
      before_send:event => {
        const choice = mode();
        if (choice === 'pending') return null;
        event.properties = { ...base, tracking_mode:choice, consent_state:consentState(), ...event.properties };
        // Preserve ad click IDs only after full analytics is allowed.
        if (choice === 'full' && event.event === '$pageview') Object.assign(event.properties, entry);
        if (choice !== 'full') {
          for (const key of Object.keys(event.properties)) {
            if (/^(?:\$?(?:initial_|latest_)?utm_[a-z0-9_]+|fbclid|fbc|gclid|gbraid|wbraid|dclid|irclid|qclid|ttclid|twclid|msclkid)$/i.test(key)) delete event.properties[key];
          }
          delete event.properties.entry_path;
          delete event.properties.referrer_host;
          delete event.properties.$referrer;
          delete event.properties.$referring_domain;
        }
        if (event.event === 'consent_choice_recorded') {
          delete event.properties.$current_url;
          delete event.properties.$referrer;
        }
        // Autocapture and pageleave can keep a browsing session active long after
        // the last semantic event. Refresh the checkout handoff from those events.
        if (choice === 'full' && /^[a-f0-9-]{36}$/i.test(event.properties.$session_id || '')) {
          try {
            localStorage.setItem(sessionKey, event.properties.$session_id);
            localStorage.setItem(sessionTimeKey, String(Date.now()));
          } catch {}
        }
        for (const key of ['$current_url','$referrer']) if(event.properties[key]) event.properties[key]=cleanUrl(event.properties[key]);
        return event;
      },
      loaded: instance => {
        sdk=instance;
        applyMode();
        resolveReady(sdk);
      }
    });
  }
  function start() {
    if (started || loading || preview || blocked || mode() === 'pending') return;
    if (window.posthog) { init(); return; }
    loading = true;
    const script=document.createElement('script');script.src='https://eu-assets.i.posthog.com/static/array.js';script.async=true;
    script.onload=() => { loading=false;init(); };
    script.onerror=() => { loading=false; };
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', () => {
    const consent = explicitConsent();
    applyMode();
    if (preview || blocked || Object.values(consent).every(value => value === 'unanswered')) return;
    const signature = JSON.stringify(consent);
    if (signature === lastConsentChange) return;
    lastConsentChange = signature;
    ready.then(instance => {
      // If another choice arrived while the SDK loaded, report only the current choice.
      if (JSON.stringify(explicitConsent()) !== signature) return;
      instance.capture('consent_choice_recorded', {
        ...base,
        analytics_choice:consent.analytics,
        marketing_choice:consent.marketing,
        preferences_choice:consent.preferences,
        tracking_mode:mode(),
        consent_state:consentState(),
      });
    });
  });
  // A storefront checkout click is an intent signal, not a hosted checkout or paid order.
  document.addEventListener('click', event => {
    if (preview || blocked) return;
    const target = event.target instanceof Element ? event.target : null;
    const control = target?.closest('button[name="checkout"], input[name="checkout"], [data-checkout-button], [data-ftb-checkout], a[href]');
    if (!control) return;
    if (control.matches('a[href]')) {
      let url;
      try { url = new URL(control.href, location.href); } catch { return; }
      if (url.origin !== location.origin || !/^\/(checkout|checkouts)(\/|$)/.test(url.pathname)) return;
    }
    window.FTBAnalytics.capture('checkout_intent_clicked', {
      ...product(), variant_id:c.variantId || null,
      placement:c.productId ? 'product' : 'cart',
    });
  }, true);
  // Semantic product actions complement masked replay and autocapture. Never read free-text inputs.
  document.addEventListener('change', event => {
    if (!c.productId || preview || blocked) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
    const picker = input.closest('variant-selects, gp-product-variants, [data-ftb-variant-picker]') || (input.matches('[data-variant-select]') ? input : null);
    if (!picker || (input instanceof HTMLInputElement && !['radio','checkbox'].includes(input.type))) return;
    const name = input.name || '';
    if (!/option|variant|color|colour|farge|färg|farve|size|storlek|scent|doft|fragrance|^id$/i.test(name) && !input.dataset.optionValueId) return;
    const optionValue = input.value;
    if (!optionValue || optionValue.length > 80) return;
    window.FTBAnalytics.capture('product_option_selected', {
      ...product(), option_name:name.slice(0,80), option_value:optionValue,
      option_value_id:input.dataset.optionValueId || null,
      variant_id:input.matches('[data-variant-select]') ? optionValue : null,
      selection_source:picker.tagName.toLowerCase(),
    });
  }, true);
  document.addEventListener('click', event => {
    if (!c.productId || preview || blocked) return;
    const target = event.target instanceof Element ? event.target : null;
    const choice = target?.closest('[data-ftb-option-name][data-ftb-option-value], .we-buying__color[data-color], .we-buying__size[data-size], .we-scented__option[data-scent]');
    if (choice) {
      const optionName = choice.getAttribute('data-ftb-option-name') || (choice.hasAttribute('data-color') ? 'color' : choice.hasAttribute('data-size') ? 'size' : 'scent');
      const optionValue = choice.getAttribute('data-ftb-option-value') || choice.getAttribute('data-color') || choice.getAttribute('data-size') || choice.getAttribute('data-scent');
      if (!optionName || optionName.length > 80 || !optionValue || optionValue.length > 80) return;
      window.FTBAnalytics.capture('product_option_selected', {
        ...product(), option_name:optionName, option_value:optionValue,
        selection_source:'white_embers_picker',
      });
      return;
    }
    const button = target?.closest('button[type="submit"], input[type="submit"], [data-ftb-purchase-cta]');
    if (!button || !(button.matches('[data-sticky-checkout], [data-checkout-button], [data-add-button]') || button.closest('form[action*="/cart/add"], product-form, gp-product-button, [data-ftb-purchase-area]'))) return;
    window.FTBAnalytics.capture('product_cta_clicked', {
      ...product(), variant_id:document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || c.variantId || null,
      placement:button.matches('[data-sticky-checkout]') || button.closest('[data-ftb-sticky], .sticky-add-to-cart, gp-sticky-add-to-cart, gp-sticky, .neckflo-product__sticky') ? 'sticky' : 'main',
    });
  }, true);
  if(window.Shopify?.customerPrivacy) start();
  else if(window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});
})();
